import { TableFromFile } from '../Tsv_parser';

function AboutGeneTypes() {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  const suffix = version === 'v254' ? '_v254' : '';

  return (
    <div>
      {' '}
      <h2 className="mt-5">
        DISGENET provides disease information for protein coding genes as well as non-coding genes
      </h2>
      <div className="table-responsive">
        <table className="table panther-table" style={{ margin: '10px 10px 0px 30px' }}>
          <thead className="text-center">
            <tr>
              <th>Type of Gene</th>
              <th>Number of genes</th>
              <th>Number of GDAS</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`../../static/files/gene_type_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AboutGeneTypes;
